<template>
  <div>
    <div style="w-100">
      <div class="d-flex" style="position: absolute; z-index: 2 !important">
        <Button
          :size="15"
          color="#fd7e14"
          colorText="#ffffff"
          tooltip="Filtrar contenido"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal', 1)"
          traslate
        />
        <Button
          :size="15"
          color="#dc3545"
          colorText="#ffffff"
          tooltip="Recargar Tabla"
          icon="fas fa-filter"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          traslate
          @click.native="recargarTabla()"
        />
        <Button
          :size="15"
          color="#28a745"
          colorText="#ffffff"
          tooltip="Exportar a Excel"
          icon="icon fas fa-file-excel"
          round
          :width="30"
          class="mt-2 mb-3 mr-2"
          @click.native="openModal('modal', 2)"
          traslate
        />
      </div>
    </div>

    <ui-modal 
      ref="modal" 
      :title="version === 1 ? 'Filtros para tabla' : 'Filtros para reporte'"
      @close="ActionSetZindexTablaModal(false)"
      size="large"  
    >
      <div class="d-flex flex-column">
        <!-- Fila 1 -->
        <div class="d-flex">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Naviera"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataListaNaviera"
            multiple
            v-model="filtroNavieraModel">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Naviera Salida"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :options="dataListaNavierasNoUCC"
            multiple
            v-model="filtroNavieraSalidaModel">
          </ui-select>
        </div>
        <div class="d-flex mt-5">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Destino"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            @change="getPODByDestination"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroDestinoModel"
            :options="dataListaDestinos">
          </ui-select>
          <ui-select
            class="w-100 ml-1 mr-1"
            has-search
            label="POL"
            multiple
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroPolModel"
            :options="dataListaPOL">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="POD"
            multiple
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            :disabled="podListDisabled"
            v-model="filtroPodModel"
            :options="!filtroDestinoModel ? dataListaPOD : podListByDestination">
          </ui-select>
        </div>
        <div class="d-flex mt-5">
          <date-picker
            class="w-100 mr-2"
            style="margin-left: -2px; font-size: 22px"
            type="date"
            value-type="format"
            @close="handleOpenChange"
            placeholder="Desde"
            v-model="filtroDesdeModel"
          />
          <date-picker
            class="w-100 ml-1 mr-1"
            style="margin-left: -2px; font-size: 22px"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Hasta"
            v-model="filtroHastaModel"
          />
          <date-picker
            class="w-100 ml-2"
            style="margin-left: -2px; font-size: 22px"
            type="date"
            value-type="format"
            :keys="{ value: 'id', label: 'name' }"
            @close="handleOpenChange"
            placeholder="Vigencia"
            v-model="filtroVigenciaModel"
          />
        </div>
        <div class="d-flex mt-5">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Tipo contenedor"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroTipoContenedorModel"
            :options="dataContenedores">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Tipo Producto"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroTipoProductoModel"
            :options="dataListaProducto">
          </ui-select>
        </div>
        <div class="d-flex mt-5">
          <ui-select
            class="w-100 mr-2"
            has-search
            label="Get Out"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ label: 'name', value: 'id' }"
            v-model="filtroGetOutModel"
            :options="[
                {id: 1, name: 'Si'},
                {id: 0, name: 'No'}
                ]">
          </ui-select>
          <ui-select
            class="w-100 ml-2"
            has-search
            label="Trat. frío"
            placeholder="Seleccionar"
            searchPlaceholder="Buscar"
            :keys="{ value: 'id', label: 'name' }"
            v-model="filtroColdtreatmentModel"
            :options="coldtreatmentList">
          </ui-select>
        </div>
      </div>
      <!-- Footer -->
      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-default" :disabled="btnState" @click="closeModal('modal')">
          Cerrar
        </button>
        <div style="float: right">
          <button
            class="btn btn-secondary"
            style="margin-right: 15px"
            :disabled="btnState"
            @click="clear"
          >
            Limpiar
          </button>
          <button class="btn btn-danger" :disabled="btnState" @click="filtrarLista" v-if="version === 1">Filtrar</button>
          <button class="btn btn-danger" :disabled="btnState" @click="generarReporte" v-if="version === 2">Generar reporte</button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Select UI
import UiSelect from "keen-ui/src/UiSelect";
import UiModal from "keen-ui/src/UiModal";
import { mapActions, mapState } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/es";
import "vue2-datepicker/index.css";

import Button from "../../../common/Button";

import {
  getTarifasLineasFiltro,
  getTarifasLineas,
  getPODByDestination,
  generarReporteTarifasLineas,
  getListasAcuerdosBase
} from "@/constants/lineas";

export default {
  props: {
    data: [Object],
  },
  data() {
    return {
      filtroNavieraModel: [],
      filtroNavieraSalidaModel: [],
      filtroPolModel: [],
      filtroPodModel: [],
      filtroDestinoModel: "",
      filtroDesdeModel: "",
      filtroHastaModel: "",
      filtroVigenciaModel: "",
      filtroTipoContenedorModel: {},
      filtroTipoProductoModel: "",
      filtroGetOutModel: "",
      filtroColdtreatmentModel: "",
      coldtreatmentList: [],
      btnState: false,
      dataFilter: this.dataDatatableTarifasLineasFiltrada,
      podListByDestination: [],
      podListDisabled: false,
      version: 1
    };
  },
  components: {
    UiSelect,
    Button,
    UiModal,
    DatePicker,
  },
  methods: {
    ...mapActions(["ActionSetZindexTablaModal"]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasLineas",
      "actionLimpiarDataTarifasLineas",
      "actionFilterDataTarifasLineas",
      'actionSetDataListarTarifasAcuerdosLineas'
    ]),
    async getPODByDestination() {

      if (this.filtroDestinoModel) {

        this.podListDisabled = true;

        this.filtroPodModel = [];

        this.podListByDestination = await getPODByDestination({ "destinations": [this.filtroDestinoModel.id] });

        this.podListDisabled = false;

      }

    },

    openModal(ref, version) {

      this.ActionSetZindexTablaModal(true);

      this.version = version;

      this.$refs[ref].open();

    },

    closeModal(ref) {
      this.$refs[ref].close();
    },

    handleOpenChange() {
      this.showTimePanel = false;
    },

    async recargarTabla() {

      this.$vToastify.loader("Recargando Tabla...");
      this.actionSetDataListarTarifasLineas([]);

      const { data_table } = await getTarifasLineas( );

      this.actionSetDataListarTarifasLineas( data_table ) ;

      this.$vToastify.stopLoader();
    },
    clear() {
      this.filtroNavieraModel = [];
      this.filtroNavieraSalidaModel = [];
      this.filtroPolModel = [];
      this.filtroPodModel = [];
      this.podListByDestination = [];
      this.filtroDestinoModel = "";
      this.filtroTipoProductoModel = "";
      this.filtroDesdeModel = "";
      this.filtroHastaModel = "";
      this.filtroVigenciaModel = "";
      this.filtroTipoContenedorModel = "";
      this.filtroGetOutModel = "";
      this.filtroColdtreatmentModel = "";
      this.actionLimpiarDataTarifasLineas();
    },
    async filtrarLista() {

      this.btnState = true;

      const form = {
        naviera_id: this.filtroNavieraModel.map(n => +n.id) ?? [],
        naviera_salida_id: this.filtroNavieraSalidaModel.map(n => +n.id) ?? [],
        pol: this.filtroPolModel.map(p => +p.id) ?? [],
        pod: this.filtroPodModel.map(p => +p.id) ?? [],
        destination_id: this.filtroDestinoModel.id ?? null,
        from_date: this.filtroDesdeModel ?? null,
        to_date: this.filtroHastaModel ?? null,
        vigencia: this.filtroVigenciaModel ?? null,
        container_id: this.filtroTipoContenedorModel.id ?? null,
        products_category_id: this.filtroTipoProductoModel.id ?? null,
        get_out: this.filtroGetOutModel.id ?? null,
        coldtreatment: this.filtroColdtreatmentModel.name ?? null
      };

      this.$vToastify.loader("Filtrando...");

      this.actionSetDataListarTarifasLineas([]);

      const { data_table } = await getTarifasLineasFiltro(form);

      this.actionSetDataListarTarifasLineas(data_table);

      this.btnState = false;

      this.closeModal("modal");

      this.$vToastify.stopLoader();

    },

    async generarReporte() {

      this.btnState = true;

      const form = {
        naviera_id: this.filtroNavieraModel.map(n => +n.id) ?? [],
        naviera_salida_id: this.filtroNavieraSalidaModel.map(n => +n.id) ?? [],
        pol: this.filtroPolModel.map(p => +p.id) ?? [],
        pod: this.filtroPodModel.map(p => +p.id) ?? [],
        destination_id: this.filtroDestinoModel.id ?? null,
        from_date: this.filtroDesdeModel ?? null,
        to_date: this.filtroHastaModel ?? null,
        vigencia: this.filtroVigenciaModel ?? null,
        container_id: this.filtroTipoContenedorModel.id ?? null,
        products_category_id: this.filtroTipoProductoModel.id ?? null,
        get_out: this.filtroGetOutModel.id ?? null,
        coldtreatment: this.filtroColdtreatmentModel.name ?? null
      };

      this.$vToastify.loader("Generando reporte...");

      const { message } = await generarReporteTarifasLineas(form);

      this.$vToastify.success(message, "Éxito");

      this.btnState = false;

      this.closeModal("modal");

      this.$vToastify.stopLoader();
    }
    
  },
  computed: {
    ...mapState("lineas", [
      "dataListaNavierasNoUCC",
      "dataDatatableTarifasLineasFiltrada",
      "dataListaPOD",
      "dataListaNaviera",
      "dataListaPOL",
      "dataListaProducto",
      "dataListaDestinos",
      'dataContenedores'
    ]),
  },
  async created() {
    const { lista_coldtreatment } = await getListasAcuerdosBase();
    this.coldtreatmentList = lista_coldtreatment || [];
  },
};
</script>

<style>
.mx-input {
  padding-left: 2px !important;
  border-radius: 0px !important;
  border: none !important;
  border-bottom: 1px solid #dcdcdc !important;
  box-shadow: none !important;
}
</style>
